/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Section_Parts_TitleInputs */

const en_ticket_section_parts_title = /** @type {(inputs: Ticket_Section_Parts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parts handling`)
};

const ja_ticket_section_parts_title = /** @type {(inputs: Ticket_Section_Parts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`部品の取り扱い`)
};

const fr_ticket_section_parts_title = /** @type {(inputs: Ticket_Section_Parts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestion des pièces`)
};

const de_ticket_section_parts_title = /** @type {(inputs: Ticket_Section_Parts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilehandhabung`)
};

/**
* | output |
* | --- |
* | "Parts handling" |
*
* @param {Ticket_Section_Parts_TitleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_section_parts_title = /** @type {((inputs?: Ticket_Section_Parts_TitleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Section_Parts_TitleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_section_parts_title(inputs)
	if (locale === "ja") return ja_ticket_section_parts_title(inputs)
	if (locale === "fr") return fr_ticket_section_parts_title(inputs)
	return de_ticket_section_parts_title(inputs)
});